export default {
    buildAuthorizeUrl() {
        return `${process.env.REACT_APP_SSO_URL}/sso/connect/authorize?state=1011098917719904&nonce=876035460422334&client_id=storeFront&redirect_uri=${encodeURIComponent(`${window.location.origin}/redirect.html`)}&response_type=id_token%20token&scope=openid%20profile%20edebe-oauth`
    },

    extractError(redirectUrl) {
        const errorMatch = redirectUrl.match(/error=([^&]+)/)
        if (!errorMatch) {
            return undefined
        }

        const errorReason = errorMatch[1]
        const errorDescriptionMatch = redirectUrl.match(/error_description=([^&]+)/)
        const errorDescription = errorDescriptionMatch ? errorDescriptionMatch[1] : ''
        return new Error(`Error during login. Reason ${errorReason} Description: ${errorDescription}`)
    },

    extractSession(redirectUrl) {
        let accessToken = null
        const accessTokenMatch = redirectUrl.match(/access_token=([^&]+)/)
        if (accessTokenMatch) {
            accessToken = accessTokenMatch[1]
        }

        // let idToken = null
        // let decodedIdToken = null
        // const idTokenMatch = redirectUrl.match(/id_token=([^&]+)/)
        // if (idTokenMatch) {
        //     idToken = idTokenMatch[1]
        //     decodedIdToken = JSON.parse(atob(idToken.split('.')[1]))
        // }

        // let expireDurationSeconds = 3600
        // const expireDurationSecondsMatch = redirectUrl.match(/expires_in=([^&]+)/)
        // if (expireDurationSecondsMatch) {
        //     expireDurationSeconds = parseInt(expireDurationSecondsMatch[1])
        // }

        return {
            accessToken,
            // expireDurationSeconds,
            // idToken,
            // decodedIdToken
        }
    },

    validateSession(session) {
        const now = (new Date()).getTime() / 1000

        const expiration = session.decodedIdToken.iat + session.expireDurationSeconds

        const minimumDuration = 60 * 15

        return (expiration - now) > minimumDuration
    },

    getAccessToken(session, resourceId) {
        return session.accessToken
    },

    getSignOutUrl(redirectUrl) {
        return `${process.env.REACT_APP_SSO_URL}/Principal/Logout`
    }
}